import React, { lazy } from "react";
import { Route } from "react-router-dom";

// Lazy-loaded Admin pages (admin-only code split)
const Dashboard = lazy(() => import("../components/pages/AdminPannel/dashboard/Dashboard"));
const Collection = lazy(() => import("../components/pages/AdminPannel/collection/Collection"));
const CustomerList = lazy(() => import("../components/pages/AdminPannel/customer/CustomerList"));
const OrderList = lazy(() => import("../components/pages/AdminPannel/order/OrderList"));
const PurchaseOrderList = lazy(() => import("../components/pages/AdminPannel/purchaseOrder/PurchaseOrderList"));
const ProductReviewList = lazy(() => import("../components/pages/AdminPannel/productReview/ProductReviewList"));
const VendorList = lazy(() => import("../components/pages/AdminPannel/Vendor/VendorList"));
const TagMaster = lazy(() => import("../components/pages/AdminPannel/tagmaster/TagMaster"));
const BrandMaster = lazy(() => import("../components/pages/AdminPannel/brandmaster/BrandMaster"));
const GlobalSearch = lazy(() => import("../components/pages/AdminPannel/globalSearch/GlobalSearch"));
const AddBlogForm = lazy(() => import("../components/pages/AdminPannel/homePage/BlogList"));
const AddBlogCategory = lazy(() => import("../components/pages/AdminPannel/homePage/AddBlogCategory"));
const MappingList = lazy(() => import("../components/pages/AdminPannel/mappingMiddleware/MappingList"));
const PriceList = lazy(() => import("../components/pages/AdminPannel/priceList/PriceList"));
const OrderDetails = lazy(() => import("../components/pages/AdminPannel/order/OrderDetails"));

export default function AdminRoutes() {
  return (
    <>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="collection" element={<Collection />} />
      <Route path="order-list" element={<OrderList />} />
      <Route path="customer-list" element={<CustomerList />} />
      <Route path="purchaseOrder-list" element={<PurchaseOrderList />} />
      <Route path="product-review" element={<ProductReviewList />} />
      <Route path="vendor-list" element={<VendorList />} />
      <Route path="tag-master" element={<TagMaster />} />
      <Route path="brand-master" element={<BrandMaster />} />
      <Route path="global-search" element={<GlobalSearch />} />
      <Route path="add-blog" element={<AddBlogForm />} />
      <Route path="add-category" element={<AddBlogCategory />} />
      <Route path="mapping-middleware" element={<MappingList />} />
      <Route path="pricing-list" element={<PriceList />} />
      <Route path="order-details" element={<OrderDetails />} />
    </>
  );
}

